<template>
	<path
		id="Vector"
		d="M11 3H12H13.5C13.7758 3 14 3.22416 14 3.5V4H2V3.5C2 3.22416 2.22416 3 2.5 3H4H5H6H10H11ZM2 14.5V7H14V14.5C14 14.7758 13.7758 15 13.5 15H2.5C2.22416 15 2 14.7758 2 14.5Z"
		stroke="#E2E2E2"
		stroke-width="2"
	/>
</template>
